/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-comment-textnodes */
import classnames from 'classnames';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import {
  addCompany,
  addCompanyGroup,
  cancelAddCompany,
  cancelAddCompanyGroup,
  cancelAddEnterpriseGroup,
  cancelDeleteCompany,
  cancelDeleteEnterprise,
  cancelEditCompany,
  cancelEditCompanyGroup,
  cancelEditEnterpriseAdmin,
  deleteCompany,
  deleteCompanyGroup,
  filterCompanies,
  getAllCompanies,
  getAllCompanyGroups,
  getAllEnterpriseAdmins,
  getCompanies,
  onRecover,
  onRecoverCompanyGroup,
  setCompanyStatus,
  showAddCompany,
  showAddCompanyGroup,
  showAddEnterpriseGroup,
  showDeleteCompany,
  showDeleteEnterprise,
  showEditCompany,
  showEditCompanyGroup,
  showEditEnterpriseAdmin,
  updateCompany,
  updateCompanyGroup,
  updateEnterpriseAdmin,
  getAllCompaniesByGroupAction,
  addEnterpriseGroup,
} from '../actions/Companies';
import AddCompanyGroupModal from '../components/AddCompanyGroupModal';
import AddCompanyModal from '../components/AddCompanyModal';
import Breadcrumbs from '../components/Breadcrumb';
import CompaniesList from '../components/CompaniesList';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import CompanyGroupList from '../components/CompanyGroupList';
import DeleteCompanyModal from '../components/DeleteCompanyModal.js';
import EditCompanyGroupModal from '../components/EditCompanyGroupModal';
import EditCompanyModal from '../components/EditCompanyModal';
import SetLimitEntries from '../components/SetLimitEntries';
import WithUserData from '../HOC/withUserData';
import filterIcon from '../Res/Icon/filter.png';
import { ENG_LOCALE } from '../lib/constants';
import CustomModal from '../components/CustomModal';
import CompanyGroupManagement from '../components/Companies/CompanyGroupManagement';
import AddSecurityCodeModal from '../components/AddSecurityCodeModal';
import { addSystemLogs } from '../actions/SystemLogs';
import { getBoxCount } from '../actions/EpikBoxes';
import { toast } from 'react-toastify';
import EnterpriseAdminList from '../components/EnterpriseAdminList';
import EnterpriseGroupManagement from '../components/Companies/EnterpriseGroupManagement';
import AddEnterpriseGroupModal from '../components/AddEnterpriseGroupModal';
import DeleteEnterpriseModal from '../components/DeleteEnterpriseModal';

const filterByOptions = ['By Company', 'By Type', 'By Group'];
const filterTypeOptions = ['All', 'Retail', 'Agency', 'Reseller', 'Partner', 'Manufacturer'];
class Companies extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.state = {
      activeCompanyTab: 'companyList',
      selectedFilter: 'By Company',
      companyType: 'all',
      securityModal: false,
      hardDelete: '',
      sort: {
        name: '',
        order: '',
      },
      dbSort: {},
    };
    // this.onDelete = this.onDelete.bind(this);
    // this.onSendFax =  this.onSendFax.bind(this);
    // this.onDownload = this.onDownload.bind(this);
  }

  async componentDidMount() {
    const {
      user,
      getAllCompanies,
      getAllCompanyGroups,
      getCompanyGroupDropdownList,
      getAllEnterpriseGroups,
    } = this.props;
    await getCompanyGroupDropdownList(this.token, null, false);
    await getAllEnterpriseGroups(this.token, null);
    const pagination = this.getPagination();
    if (
      user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'supportEngineer'
    ) {
      await getAllCompanies(this.token, pagination, 'no', this.state.companyType);
      await getAllCompanyGroups(this.token, pagination);
    } else {
      // await getAllCompanyGroups(this.token, pagination);
      await getAllCompanies(this.token, '', 'no', this.state.companyType);
    }
  }

  getSearchResultsByGroupName = async event => {
    if (event.value == null) {
      this.props.getCompanies(this.token, undefined, 'yes');
      this.props.getAllCompanies(this.token, this.getPagination());
    }
    if (event.value === '') {
      await getCompanies(this.token, undefined, 'yes');
      this.props.getAllCompanies(this.token, this.getPagination());
    } else if (event.value !== undefined && event.value !== null) {
      await this.props.getAllCompaniesByGroup(this.token, event.suggestion._id);
    }
  };

  selectedCompanyDetails = companyId => {
    const { companiesList } = this.props;
    const company = companiesList?.docs?.filter(company => company._id === companyId);
    return company[0];
  };

  selectedEnterpriseDetails = enterpriseId => {
    const { enterpriseAdminList } = this.props;
    const enterprise = enterpriseAdminList?.docs?.filter(
      enterprise => enterprise._id === enterpriseId,
    );
    return enterprise[0];
  };

  onConfirm = async () => {
    const pagination = this.getPagination();
    const { hardDelete } = this.state;
    const {
      deleteCompanyID,
      deleteCompanyGroup: deleteCompanyGroup_,
      getAllCompanyGroups: getAllCompanyGroups_,
      addSystemLogs,
      getBoxCount,
    } = this.props;

    const selectedCompany = this.selectedCompanyDetails(deleteCompanyID);
    const companyCount = await getBoxCount(this.token, selectedCompany._id);
    const deletedValidate = Object.values(companyCount).every(count => count === 0);

    if (deletedValidate) {
      const response = await deleteCompanyGroup_(this.token, deleteCompanyID, hardDelete);
      this.setState({ securityModal: false });

      if (response) {
        const body = {
          actionType: 'system',
          description: `Company: ${selectedCompany.name} has been deleted`,
        };
        await addSystemLogs(this.token, body);
        await getAllCompanyGroups_(this.token, pagination);
      }
    } else {
      toast.error('Company still has Devices Assigned. Please delete the Assigned Devices first.');
      this.setState({ securityModal: false });
    }
  };

  deleteCompany = async () => {
    const pagination = this.getPagination();
    const { companyType } = this.state;

    const {
      deleteCompanyID,
      deleteCompany: deleteCompany_,
      getAllCompanies: getAllCompanies_,
      addSystemLogs,
    } = this.props;
    const selectedCompany = this.selectedCompanyDetails(deleteCompanyID);
    await deleteCompany_(this.token, deleteCompanyID);
    const body = {
      actionType: 'system',
      description: `Company: ${selectedCompany.name} has been deleted`,
    };

    await addSystemLogs(this.token, body);
    await getAllCompanies_(this.token, pagination, 'no', companyType);
    this.setState({ securityModal: false });
  };

  deleteEnterprise = async () => {
    const {
      deleteEnterpriseID,
      addSystemLogs,
      editEnterpriseGroup,
      getAllEnterpriseGroups,
    } = this.props;

    const selectedEnterprise = this.selectedEnterpriseDetails(deleteEnterpriseID);

    const deleteBody = {
      _id: deleteEnterpriseID,
      isDeleted: true,
    };

    await editEnterpriseGroup(this.token, deleteBody);

    const body = {
      actionType: 'system',
      description: `Enterprise Admin: ${selectedEnterprise.name} has been deleted`,
    };

    await addSystemLogs(this.token, body);
    const pagination = this.getPagination();
    await getAllEnterpriseGroups(this.token, pagination);
    this.setState({ securityModal: false });
  };

  onDelete = async () => {
    const { modalData } = this.state;
    const isCompany = 'Company';
    if (modalData === isCompany) {
      this.deleteCompany();
    } else if (modalData === 'Enterprise Admin') {
      this.deleteEnterprise();
    }
  };

  onAddCompany = async () => {
    const { addedCompany, addSystemLogs, addCompany, getAllCompanies, getCompanies } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    if (addedCompany['name']) {
      addedCompany['name'] = addedCompany['name'].trim();
    }
    await addCompany(token, addedCompany);
    const body = {
      actionType: 'system',
      description: `Company:${addedCompany.name} has been added`,
    };

    await addSystemLogs(this.token, body);
    const pagination = this.getPagination();
    await getAllCompanies(this.token, pagination);
    getCompanies(this.token, undefined, 'yes');
  };

  onAddCompanyGroup = async () => {
    const { addCompanyGroupChange, getAllCompanyGroups } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    if (addCompanyGroupChange['name']) {
      addCompanyGroupChange['name'] = addCompanyGroupChange['name'].trim();
    }
    await this.props.addCompanyGroup(token, addCompanyGroupChange);
    const pagination = this.getPagination();
    await getAllCompanyGroups(this.token, pagination);
  };

  onAddEnterpriseGroup = async () => {
    const { addEnterpriseGroupChange, getAllEnterpriseGroups, addEnterpriseGroup } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    if (addEnterpriseGroupChange.name) {
      addEnterpriseGroupChange.name = addEnterpriseGroupChange.name.trim();
    }
    console.log('addEnterpriseGroupChange', addEnterpriseGroupChange);

    await addEnterpriseGroup(token, addEnterpriseGroupChange);
    const pagination = this.getPagination();
    await getAllEnterpriseGroups(this.token, pagination);
  };

  editCompany = async () => {
    const { addedCompany, editCompanyData } = this.props;
    const token = localStorage.getItem('jwtToken') || null;
    if (addedCompany['name']) {
      addedCompany['name'] = addedCompany['name'].trim();
    }
    await this.props.editCompany(token, editCompanyData._id, {
      ...addedCompany,
      name: addedCompany?.name || editCompanyData['name'],
    });
    const pagination = this.getPagination();
    await this.props.getAllCompanies(this.token, pagination);
  };

  editCompanyGroup = async addCompanyGroupChange => {
    const { editCompanyGroupData, getAllCompanyGroups } = this.props;
    const token = localStorage.getItem('jwtToken') || null;

    if (addCompanyGroupChange['name']) {
      addCompanyGroupChange['name'] = addCompanyGroupChange['name'].trim();
    }
    await this.props.editCompanyGroup(token, editCompanyGroupData._id, addCompanyGroupChange);
    const pagination = this.getPagination();
    await getAllCompanyGroups(this.token, pagination);
  };

  editEnterpriseGroup = async addCompanyGroupChange => {
    const { editEnterpriseGroupData, editEnterpriseGroup, getAllEnterpriseGroups } = this.props;

    const token = localStorage.getItem('jwtToken') || null;
    let { name } = addCompanyGroupChange;
    if (name) {
      name = name.trim();
    }

    const { company, ...rest } = addCompanyGroupChange;
    const body = {
      _id: editEnterpriseGroupData._id,
      ...rest,
    };

    await editEnterpriseGroup(token, body);
    const pagination = this.getPagination();
    await getAllEnterpriseGroups(this.token, pagination);
  };

  onSetStatus = async (id, status) => {
    await this.props.setCompanyStatus(this.token, id, status);
    const pagination = this.getPagination();
    this.props.getAllCompanies(this.token, pagination);
  };

  handleChangePagination = async page => {
    const { dbSort, companyType } = this.state;
    const { getAllCompanies, companiesList } = this.props;
    const { limit } = companiesList;
    const pagination = { page, limit, sort: dbSort };
    await getAllCompanies(this.token, pagination, undefined, companyType);
  };

  getPagination = () => {
    const { page, limit } = this.props.companiesList;
    const pagination = { page, limit };
    return pagination;
  };

  handleSetLimit = limit =>
    this.props.getAllCompanies(this.token, { page: 1, limit }, undefined, this.state.companyType);

  textSearchFilter = async e => {
    const { getCompanies, filterCompanies } = this.props;
    if (e.value == null) {
      this.props.getCompanies(this.token, undefined, 'yes');
      this.props.getAllCompanies(this.token, this.getPagination());
    }
    if (e.value === '') {
      await getCompanies(this.token, undefined, 'yes');
      this.props.getAllCompanies(this.token, this.getPagination());
    } else if (e.value !== undefined && e.value !== null) {
      await filterCompanies(this.token, e.value);
    }
  };

  filterByCompanyFn = async e => {
    const { getAllCompanies } = this.props;
    this.setState({ companyType: e.target.value.toLowerCase() });
    await getAllCompanies(this.token, undefined, undefined, e.target.value.toLowerCase());
  };

  onRecoverCompany = async e => {
    const pagination = this.getPagination();
    let res;
    if (this.state.modalData === 'Company') {
      res = await this.props.onRecover(this.token, e);
      if (res) {
        setTimeout(() => {
          this.props.getAllCompanies(this.token, pagination, 'no', this.state.companyType);
        }, 1000);
      }
    } else {
      res = await this.props.onRecoverCompanyGroup(this.token, e);
      if (res) {
        await this.props.getAllCompanyGroups(this.token, pagination);
      }
    }
  };

  handleSortCompanies = async filter => {
    const { sort, companyType } = this.state;
    const { getAllCompanies } = this.props;
    const updateSort = { ...sort };
    const pagination = this.getPagination();

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    const sortQuery = { [updateSort?.name]: updateSort?.order === 'asc' ? 1 : -1 };
    await getAllCompanies(this.token, { ...pagination, sort: sortQuery }, 'no', companyType);
    this.setState({ sort: updateSort, dbSort: sortQuery });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;
    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(
        array,
        [
          el =>
            el[sortNameArr[0]] === undefined
              ? ''
              : el[sortNameArr[0]][sortNameArr[1]].toLowerCase(),
        ],
        [sort.order],
      );
    } else if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name]?.toLowerCase()], [sort.order]);
    } else if (sort.name.indexOf('{') !== -1) {
      const sortNameArr = sort.name.replace(/[\{\}']+/g, ' ').split(' ');
      return orderBy(
        array,
        [el => (el[sortNameArr[0]] > el[sortNameArr[1]] ? el[sortNameArr[0]] : el[sortNameArr[1]])],
        [sort.order],
      );
    } else {
      return orderBy(array, [el => el[sort.name]], [sort.order]);
    }
  };

  renderFilterTypes = () => {
    const { selectedFilter } = this.state;
    const { companies, companyGroupDropdownList } = this.props;
    if (selectedFilter === 'By Company') {
      return (
        <CompanyAutocomplete
          placeholder="Filter"
          companies={companies.docs}
          onChange={this.textSearchFilter}
        />
      );
    }
    if (selectedFilter === 'By Type') {
      return (
        <Input
          type="select"
          style={{ maxWidth: '200px' }}
          onChange={e => this.filterByCompanyFn(e)}
        >
          {filterTypeOptions.map(el => (
            <option key={el} value={el}>
              {el}
            </option>
          ))}
        </Input>
      );
    }

    return (
      <CompanyAutocomplete
        placeholder="Filter"
        companies={companyGroupDropdownList.docs}
        onChange={this.getSearchResultsByGroupName}
      />
    );
  };
  onEditPress = e => {
    this.props.showEditCompanyGroup(e);
    this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
  };

  onEditEnterPrise = e => {
    this.props.showEditEnterpriseAdmin(e);
    this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
  };

  render() {
    const { user, companiesList, companyGroupList, deleteMode, enterpriseAdminList } = this.props; // let companiesToShow = [];
    // let companyGroupsToShow = [];
    // if (companiesList.docs) {
    //   companiesToShow = companiesList.docs && companiesList.docs.filter(c => !c.deleted);
    // }
    // if (companyGroupList.docs) {
    //   companyGroupsToShow = companyGroupList.docs && companyGroupList.docs.filter(c => !c.deleted);
    // }
    const { sort } = this.state;
    const renderList = sort.name.length
      ? companiesList?.docs?.length && this.sortColumnByKey(companiesList.docs)
      : companiesList.docs;

    return (
      <div>
        <div className="filter-section">
          <Row>
            {/* <Col md={6} sm={12}>
              <Breadcrumbs />
            </Col> */}
            <Col md={12} sm={12} >
              <Row className="d-flex justify-content-end">
                {user.role !== 'companyGroupManager' ? (
                  <Col md={2} className="float-right">
                    {(this.state.activeCompanyTab === 'companyList' && (
                      <Button
                        className="float-right"
                        onClick={this.props.showAddCompany}
                        color="primary"
                      >
                        New Company
                      </Button>
                    )) ||
                      (this.state.activeCompanyTab === 'enterpriseManagement' && (
                        <Button
                          className="float-right"
                          onClick={() => {
                            this.props.showAddEnterpriseGroup();
                            this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
                          }}
                          color="primary"
                        >
                          New Enterprise Admin
                        </Button>
                      )) || (
                        <Button
                          className="float-right"
                          onClick={() => {
                            this.props.showAddCompanyGroup();
                            this.props.getCompanies(this.token, undefined, 'yes', 'all', false);
                          }}
                          color="primary"
                        >
                          Create New Group
                        </Button>
                      )}
                  </Col>
                ) : null}
                <Col md={4} className="select-limit">
                  {this.props.companies.docs && (
                    <>
                      <InputGroup>
                        <InputGroupAddon addonType="prepend" className="filter-icon-div">
                          <img src={filterIcon} className="filter-icon" alt="..." />
                        </InputGroupAddon>
                        <Input
                          type="select"
                          className="filter-append-dropdown"
                          onChange={e => {
                            this.props.getAllCompanies(this.token, '', 'no', 'all');
                            this.setState({ selectedFilter: e.target.value });
                          }}
                        >
                          {filterByOptions.map(el => (
                            <option key={el} value={el}>
                              {el}
                            </option>
                          ))}
                        </Input>
                      </InputGroup>
                      {this.renderFilterTypes()}
                      {/* {this.state.selectedFilter === 'By Company' ? (
                        <CompanyAutocomplete
                          placeholder="Filter"
                          companies={this.props.companies.docs}
                          onChange={this.textSearchFilter}
                        />
                      ) : this.state.selectedFilter === 'By Type' ? (
                        <Input
                          type="select"
                          style={{ maxWidth: '200px' }}
                          onChange={e => this.filterByCompanyFn(e)}
                        >
                          {filterTypeOptions.map(el => (
                            <option key={el} value={el}>
                              {el}
                            </option>
                          ))}
                        </Input>
                      ) : (
                        <CompanyAutocomplete
                          placeholder="Filter"
                          companies={this.props.companies.docs}
                          onChange={this.textSearchFilter}
                        />
                      )} */}
                    </>
                  )}
                </Col>
                {/* <Col md="3">
                  <SetLimitEntries onChange={this.handleSetLimit} />
                </Col> */}
              </Row>
            </Col>
          </Row>
        </div>
        <Container fluid style={{ margin: 0 }}>
          <div className="viewContainer" style={{ marginTop: '20px' }}>
            {user.role === 'superAdmin' ? (
              <ButtonGroup className="tab-group">
                <Button
                  className={classnames({ active: this.state.activeCompanyTab === 'companyList' })}
                  onClick={() => {
                    this.setState({ activeCompanyTab: 'companyList' });
                  }}
                >
                  Companies
                </Button>
                <Button
                  className={classnames({
                    active: this.state.activeCompanyTab === 'groupManagement',
                  })}
                  onClick={() => {
                    this.setState({ activeCompanyTab: 'groupManagement' });
                  }}
                >
                  Group Management
                </Button>
                <Button
                  className={classnames({
                    active: this.state.activeCompanyTab === 'enterpriseManagement',
                  })}
                  onClick={() => {
                    this.setState({ activeCompanyTab: 'enterpriseManagement' });
                  }}
                >
                  Enterprise Management
                </Button>
              </ButtonGroup>
            ) : null}

            <Row>
              <Col md="12">
                <TabContent activeTab={this.state.activeCompanyTab}>
                  <TabPane tabId="companyList">
                    <Row>
                      <Col md={12}>
                        <CompaniesList
                          onRecover={e => {
                            this.setState({ modalData: 'Company' }, () => {
                              this.onRecoverCompany(e);
                            });
                          }}
                          deleteMode={deleteMode}
                          user={user}
                          companies={renderList}
                          disabledCompany={user.company._id}
                          onDelete={e => {
                            this.setState({ modalData: 'Company' }, () => {
                              this.props.showDeleteCompany(e);
                            });
                          }}
                          onEdit={this.props.showEditCompany}
                          onSetStatus={this.onSetStatus}
                          isLoading={this.props.usersLoading}
                          onSort={this.handleSortCompanies}
                          sortValue={sort}
                        />

                        {companiesList.totalPages > 1 && (
                          <Row className="justify-content-md-center">
                            <SetLimitEntries onChange={this.handleSetLimit} />

                            <Pagination
                              locale={ENG_LOCALE}
                              className="pagination-container"
                              onChange={this.handleChangePagination}
                              current={companiesList.page}
                              total={companiesList.totalDocs}
                              pageSize={companiesList.limit}
                              showLessItems={true}
                              showTotal={(total, range) =>
                                `${range[0]} - ${range[1]} of ${total} items`
                              }
                            />
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeCompanyTab}>
                  <TabPane tabId="groupManagement">
                    <Row>
                      <Col md={12}>
                        <CompanyGroupList
                          onRecover={e => {
                            this.setState({ modalData: 'Company Group' }, () => {
                              this.onRecoverCompany(e);
                            });
                          }}
                          deleteMode={deleteMode}
                          user={user}
                          companies={
                            sort.name.length
                              ? companyGroupList?.docs?.length &&
                              this.sortColumnByKey(companyGroupList.docs)
                              : companyGroupList.docs
                          }
                          disabledCompany={user.company._id}
                          onDelete={e => {
                            this.setState({ modalData: 'Company Group' }, () => {
                              this.props.showDeleteCompany(e);
                            });
                          }}
                          onEdit={this.onEditPress}
                          onSetStatus={this.onSetStatus}
                          isLoading={this.props.usersLoading}
                          onSort={this.handleSortCompanies}
                          sortValue={sort}
                        />
                        {/* {companyGroupsToShow.totalPages > 1 && (
                      <Pagination
                        className="pagination-container"
                        onChange={this.handleChangePagination}
                        current={companyGroupsToShow.page}
                        total={companyGroupsToShow.totalDocs}
                        pageSize={companyGroupsToShow.limit}
                        showLessItems={true}
                      />
                    )} */}
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
                <TabContent activeTab={this.state.activeCompanyTab}>
                  <TabPane tabId="enterpriseManagement">
                    <Row>
                      <Col md={12}>
                        <EnterpriseAdminList
                          onRecover={e => {
                            this.setState({ modalData: 'Enterprise Admin' }, () => {
                              this.onRecoverCompany(e);
                            });
                          }}
                          deleteMode={deleteMode}
                          user={user}
                          companies={
                            sort.name.length
                              ? enterpriseAdminList?.docs?.length &&
                              this.sortColumnByKey(enterpriseAdminList?.docs)
                              : enterpriseAdminList?.docs
                          }
                          disabledCompany={user.company._id}
                          onDelete={e => {
                            this.setState({ modalData: 'Enterprise Admin' }, () => {
                              this.props.showDeleteEnterprise(e);
                            });
                          }}
                          onEdit={this.onEditEnterPrise}
                          onSetStatus={this.onSetStatus}
                          isLoading={this.props.usersLoading}
                          onSort={this.handleSortCompanies}
                          sortValue={sort}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </div>
          <AddSecurityCodeModal
            isOpen={this.state.securityModal}
            onCancel={() => {
              this.setState({ securityModal: false });
            }}
            onConfirm={
              this.state.modalData === 'Company' || this.state.modalData === 'Enterprise Admin'
                ? this.onDelete
                : this.onConfirm
            }
            // modalName={`${this.state.modalData === 'Company'?"deleteCompany": this.state.modalData === 'Enterprise Admin'&&"deleteEnterpise"}`}
            featureName={`${this.state.modalData === 'Company' ? "deleteCompany" : this.state.modalData === 'Enterprise Admin' && "deleteEnterprise"}`}
          />

          <DeleteCompanyModal
            modalData={this.state.modalData}
            isOpen={this.props.deleteCompanyShow}
            onCancel={this.props.cancelDeleteCompany}
            onConfirm={e => {
              this.setState({ hardDelete: e });
              this.setState({ securityModal: true });
            }}
          />

          <DeleteEnterpriseModal
            modalData={this.state.modalData}
            isOpen={this.props.deleteEnterpriseShow}
            onCancel={this.props.cancelDeleteEnterprise}
            onConfirm={e => {
              this.setState({ hardDelete: e });
              this.setState({ securityModal: true });
            }}
          />

          <AddCompanyModal
            isOpen={this.props.addCompanyShow}
            onCancel={this.props.addCompanyCancel}
            onConfirm={this.onAddCompany}
          />
          <AddCompanyGroupModal
            isOpen={this.props.addCompanyGroupShow}
            onCancel={this.props.addCompanyGroupCancel}
            onConfirm={this.onAddCompanyGroup}
          />
          <AddEnterpriseGroupModal
            isOpen={this.props.addEnterpriseGroupShow}
            onCancel={this.props.addEnterpriseGroupCancel}
            onConfirm={this.onAddEnterpriseGroup}
          />
          <EditCompanyModal
            isOpen={this.props.editCompanyShow}
            onCancel={this.props.editCompanyCancel}
            onConfirm={this.editCompany}
          />
          {/* <EditCompanyGroupModal
            isOpen={this.props.editCompanyGroupShow}
            onCancel={this.props.editCompanyGroupCancel}

          /> */}
          <CustomModal
            header={'Company Group Management - Granite'}
            isOpen={this.props.editCompanyGroupShow}
            // onConfirm={onReleasePublish}
            hideFooter
            wider
          >
            <CompanyGroupManagement
              onConfirm={this.editCompanyGroup}
              onCancel={this.props.editCompanyGroupCancel}
            />
          </CustomModal>
          <CustomModal
            header={'Enterprise Group Management - Granite'}
            isOpen={this.props.editEnterpriseGroupShow}
            // onConfirm={onReleasePublish}
            hideFooter
            wider
          >
            <EnterpriseGroupManagement
              onConfirm={this.editEnterpriseGroup}
              onCancel={this.props.editEnterpriseGroupCancel}
            />
          </CustomModal>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  companyGroupDropdownList: state.AppState.companyGroupListDropdown,
  user: state.AppState.user,
  companies: state.AppState.companies,
  companiesList: state.AppState.companiesList,
  companyGroupList: state.AppState.companyGroupList,
  enterpriseAdminList: state.AppState.enterpriseAdmins,
  deleteCompanyShow: state.UIState.companies.deleteCompanyShow,
  deleteEnterpriseShow: state.UIState.companies.deleteEnterpriseShow,
  addCompanyShow: state.UIState.companies.addCompanyShow,
  addCompanyGroupShow: state.UIState.companies.addCompanyGroupShow,
  addEnterpriseGroupShow: state.UIState.companies.addEnterpriseGroupShow,
  editEnterpriseGroupData: state.UIState.companies.editEnterpriseGroupData,
  editCompanyShow: state.UIState.companies.editCompanyShow,
  editCompanyGroupShow: state.UIState.companies.editCompanyGroupShow,
  editEnterpriseGroupShow: state.UIState.companies.editEnterpriseGroupShow,
  deleteCompanyID: state.UIState.companies.deleteCompanyID,
  deleteEnterpriseID: state.UIState.companies.deleteEnterpriseID,
  companiesLoading: state.UIState.companies.companiesLoading,
  addedCompany: state.UIState.companies.addedCompany,
  addedCompanyGroup: state.UIState.companies.addedCompanyGroup,
  editCompanyData: state.UIState.companies.editCompanyData,
  editCompanyGroupData: state.UIState.companies.editCompanyGroupData,
  companyFilter: state.UIState.epikBoxes.companyFilter,
  addCompanyGroupChange: state.UIState.companies.addCompanyGroupChange,
  addEnterpriseGroupChange: state.UIState.companies.addEnterpriseGroupChange,
  deleteMode: state.AppState.deleteMode,
});

const mapDispatchToProps = dispatch => ({
  getAllCompaniesByGroup: (token, groupID) =>
    dispatch(getAllCompaniesByGroupAction(token, groupID)),
  getCompanyGroupDropdownList: (token, pagination, paginateResult) =>
    dispatch(getAllCompanyGroups(token, pagination, paginateResult)),
  onRecoverCompanyGroup: (token, id) => dispatch(onRecoverCompanyGroup(token, id)),
  onRecover: (token, id) => dispatch(onRecover(token, id)),
  getCompanies: (token, pagination, disablePaginate, type, getDeleted) =>
    dispatch(getCompanies(token, pagination, disablePaginate, type, getDeleted)),
  getAllCompanies: (token, pagination, disablePagination, type) =>
    dispatch(getAllCompanies(token, pagination, disablePagination, type)),
  getAllCompanyGroups: (token, pagination) => dispatch(getAllCompanyGroups(token, pagination)),
  getAllEnterpriseGroups: (token, pagination) =>
    dispatch(getAllEnterpriseAdmins(token, pagination)),
  filterCompanies: (token, company, pagination) =>
    dispatch(filterCompanies(token, company, pagination)),
  showEditCompany: id => dispatch(showEditCompany(id)),
  showEditCompanyGroup: data => dispatch(showEditCompanyGroup(data)),
  showEditEnterpriseAdmin: id => dispatch(showEditEnterpriseAdmin(id)),
  editCompanyCancel: () => dispatch(cancelEditCompany()),
  editCompanyGroupCancel: () => dispatch(cancelEditCompanyGroup()),
  editEnterpriseGroupCancel: () => dispatch(cancelEditEnterpriseAdmin()),
  editCompany: (token, id, company) => dispatch(updateCompany(token, id, company)),
  editCompanyGroup: (token, id, company) => dispatch(updateCompanyGroup(token, id, company)),
  editEnterpriseGroup: (token, company) => dispatch(updateEnterpriseAdmin(token, company)),
  showAddCompany: () => dispatch(showAddCompany()),
  showAddCompanyGroup: () => dispatch(showAddCompanyGroup()),
  showAddEnterpriseGroup: () => dispatch(showAddEnterpriseGroup()),
  addCompanyCancel: () => dispatch(cancelAddCompany()),
  addCompanyGroupCancel: () => dispatch(cancelAddCompanyGroup()),
  addEnterpriseGroupCancel: () => dispatch(cancelAddEnterpriseGroup()),
  addCompany: (token, company) => dispatch(addCompany(token, company)),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
  addCompanyGroup: (token, company) => dispatch(addCompanyGroup(token, company)),
  addEnterpriseGroup: (token, company) => dispatch(addEnterpriseGroup(token, company)),
  deleteCompany: (token, id) => dispatch(deleteCompany(token, id)),
  deleteCompanyGroup: (token, id, hardDelete) =>
    dispatch(deleteCompanyGroup(token, id, hardDelete)),
  showDeleteCompany: id => dispatch(showDeleteCompany(id)),
  showDeleteEnterprise: id => dispatch(showDeleteEnterprise(id)),
  cancelDeleteCompany: () => dispatch(cancelDeleteCompany()),
  cancelDeleteEnterprise: () => dispatch(cancelDeleteEnterprise()),
  setCompanyStatus: (token, id, status) => dispatch(setCompanyStatus(token, id, status)),
  getBoxCount: (token, companyID) => dispatch(getBoxCount(token, companyID)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Companies));
